import { render, staticRenderFns } from "./recording-force.vue?vue&type=template&id=6ddd7e70"
import script from "./recording-force.vue?vue&type=script&lang=js"
export * from "./recording-force.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports